import handleCalendarsResponse from './request/handleCalendarsResponse'

export default function(api: GlobalFetch) {
  return async function(): Promise<number> {
    const response = await api.fetch('/api/v2/calendar/index')

    return await handleCalendarsResponse(response)
  }
}
